import { PortfolioData } from '@/utils/portfolios';
import { benchmarkToBasicBenchmark } from '../../shared';
import Dictionary from '@/types/dictionary';
import BasicBenchmark from '@/types/basic-benchmark';

/**
 * Gets the portfolio's benchmarks per holding
 * @param {PortfolioData} portfolio the portfolio data
 * @return {Dictionary<Benchmark>} returns the market benchmarks and riskFree benchmark per holding
 */
export const getPortfolioBenchmarks = (portfolio: PortfolioData) => {
  const riskFreeBenchmarks = portfolio.benchmarks.reduce((acc, curr) => {
    for (const fund of portfolio.funds) {
      if (curr.lipperId === fund.riskFreeLipperId) {
        acc[fund._id] = benchmarkToBasicBenchmark(curr);
      }
    }
    for (const stock of portfolio.stocks) {
      if (curr.lipperId === stock.riskFreeId) {
        acc[stock._id] = benchmarkToBasicBenchmark(curr);
      }
    }
    return acc;
  }, {} as Dictionary<BasicBenchmark>);

  const marketBenchmarks = portfolio.benchmarks.reduce((acc, curr) => {
    for (const fund of portfolio.funds) {
      if (curr.lipperId === fund.benchmarkLipperId) {
        acc[fund._id] = benchmarkToBasicBenchmark(curr);
      }
    }
    for (const stock of portfolio.stocks) {
      if (curr.lipperId === stock.benchmarkId) {
        acc[stock._id] = benchmarkToBasicBenchmark(curr);
      }
    }
    return acc;
  }, {} as Dictionary<BasicBenchmark>);
  return {
    marketBenchmarks: Object.keys(marketBenchmarks).length ? marketBenchmarks : undefined,
    riskFreeBenchmarks: Object.keys(riskFreeBenchmarks).length ? riskFreeBenchmarks : undefined,
  };
};
